/**
 * Feriados nacionais (03/11/2026, André: Finados 02/11 contou no prazo e os cards
 * ficaram atrasados). Fixos + Sexta-feira Santa; contam como sábado/domingo.
 */
const FERIADOS_FIXOS = new Set(['1-1', '4-21', '5-1', '9-7', '10-12', '11-2', '11-15', '11-20', '12-25']);
const sextaSantaCache: Record<number, string> = {};

function sextaSanta(ano: number): string {
  if (!sextaSantaCache[ano]) {
    const a = ano % 19, b = Math.floor(ano / 100), c = ano % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31), dia = ((h + l - 7 * m + 114) % 31) + 1;
    const pascoa = new Date(ano, mes - 1, dia);
    pascoa.setDate(pascoa.getDate() - 2);
    sextaSantaCache[ano] = `${pascoa.getMonth() + 1}-${pascoa.getDate()}`;
  }
  return sextaSantaCache[ano];
}

export function ehFeriado(d: Date): boolean {
  const chave = `${d.getMonth() + 1}-${d.getDate()}`;
  return FERIADOS_FIXOS.has(chave) || sextaSanta(d.getFullYear()) === chave;
}

/**
 * Calcula horas entre duas datas excluindo sábados, domingos e feriados nacionais.
 * Conta apenas o tempo que cai em dias úteis (seg-sex).
 */
export function calcularHorasUteis(inicio: Date, fim: Date): number {
  if (fim <= inicio) return 0;

  let totalMs = 0;
  const current = new Date(inicio);

  while (current < fim) {
    const dayOfWeek = current.getDay(); // 0=Domingo, 6=Sábado
    if (dayOfWeek !== 0 && dayOfWeek !== 6 && !ehFeriado(current)) {
      // Dia útil — contar até o fim do dia ou até `fim`, o que vier primeiro
      const nextDay = new Date(current);
      nextDay.setDate(nextDay.getDate() + 1);
      nextDay.setHours(0, 0, 0, 0);
      const dayEnd = nextDay < fim ? nextDay : fim;
      totalMs += dayEnd.getTime() - current.getTime();
    }
    // Avançar para o início do próximo dia
    current.setDate(current.getDate() + 1);
    current.setHours(0, 0, 0, 0);
  }

  return totalMs / (1000 * 60 * 60);
}

/**
 * Calcula horas entre duas datas, opcionalmente excluindo fins de semana.
 */
export function calcularHorasSLA(inicio: Date, fim: Date, ignorarFimDeSemana?: boolean): number {
  if (ignorarFimDeSemana) {
    return calcularHorasUteis(inicio, fim);
  }
  return Math.max(0, (fim.getTime() - inicio.getTime()) / (1000 * 60 * 60));
}

/**
 * Quando o card entrou na etapa ATUAL.
 *
 * Percorre o histórico de trás pra frente de propósito: um card que já passou
 * pela etapa antes e voltou tem várias entradas, e a que vale é a última.
 * Usar a primeira (o que o badge do Kanban fazia) infla o tempo de permanência.
 */
export function entradaNaEtapa(
  etapaHistory: Array<{ etapaId: string; movedAt: Date | string }> | undefined,
  etapaId: string
): Date | null {
  if (!etapaHistory?.length) return null;

  for (let i = etapaHistory.length - 1; i >= 0; i--) {
    const h = etapaHistory[i];
    if (String(h.etapaId) !== String(etapaId)) continue;
    const d = new Date(h.movedAt as any);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}

/**
 * Quantas vezes o card já passou do SLA da etapa.
 * 0 = dentro do prazo, 1 = estourou, 2 = dobrou, 3 = triplicou...
 *
 * A partir de 2 o card é tratado como escalonado (vermelho pulsante no quadro
 * e e-mail subindo a hierarquia — ver escalonamentoSla na etapa).
 */
export function nivelEstouroSLA(horasNaEtapa: number, tempoMaximoHoras?: number): number {
  if (!tempoMaximoHoras || tempoMaximoHoras <= 0) return 0;
  return Math.floor(horasNaEtapa / tempoMaximoHoras);
}

/** A partir daqui o card entra em escalonamento (dobrou o prazo). */
export const NIVEL_ESCALONAMENTO_SLA = 2;

/**
 * Horas de SLA para o minicard: "5h40", "12h", ou "45min" quando falta menos de 1h
 * (senão o card mostraria "0h" durante a última hora inteira). Os minutos foram pedido
 * da Milena em 06/10/2026: "faltam 5h" redondo não dizia se eram 5h10 ou 5h50.
 */
export function formatarHorasSLA(horas: number): string {
  const totalMin = Math.floor(Math.max(0, horas) * 60);
  if (totalMin < 60) return `${totalMin}min`;
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return m ? `${h}h${String(m).padStart(2, '0')}` : `${h}h`;
}
